import type { ZohoContact } from '@deltasuite/zoho-client';
import { dialApiFetch, isDialApiConfigured } from './client';
import { MOCK_CONTACTS } from './mock';

export interface SiblingsResponse {
  data: readonly ZohoContact[];
  info: { count: number };
}

// Fetches sibling contacts at the same company (Account_Name.id), excluding
// the primary. Powers the Database Update side panel. Live-fetched via the
// Zoho proxy — no local cache, freshness matters more than latency on 6
// rows (reframe Q2).
export async function getSiblings(
  companyId: string,
  excludeContactId: string,
  limit = 6,
): Promise<SiblingsResponse> {
  if (!isDialApiConfigured) {
    // Demo path: scan MOCK_CONTACTS for matching Account_Name.id.
    const filtered = MOCK_CONTACTS.filter(
      (c) => c.Account_Name?.id === companyId && c.id !== excludeContactId,
    );
    return { data: filtered.slice(0, limit), info: { count: filtered.length } };
  }
  const qs = new URLSearchParams();
  qs.set('exclude', excludeContactId);
  qs.set('limit', String(limit));
  return dialApiFetch<SiblingsResponse>(
    `/v1/contacts/by-company/${encodeURIComponent(companyId)}?${qs.toString()}`,
  );
}
